import { parse } from '../../util/urlHelpers';
import { storableError } from '../../util/errors';

// ================ Action types ================ //
export const FETCH_USERS_REQUEST = 'app/AdminUsersPage/FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'app/AdminUsersPage/FETCH_USERS_SUCCESS';
export const FETCH_USERS_ERROR = 'app/AdminUsersPage/FETCH_USERS_ERROR';

export const DELETE_USER_REQUEST = 'app/AdminUsersPage/DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'app/AdminUsersPage/DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR = 'app/AdminUsersPage/DELETE_USER_ERROR';

// ================ Reducer ================ //
const initialState = {
  fetchInProgress: false,
  fetchError: null,
  pagination: null,
  users: [],
  deleteInProgress: false,
  deleteError: null,
};

export default function adminUsersPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_USERS_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null, deleteError: null };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        fetchInProgress: false,
        users: payload.data,
        pagination: payload.meta,
      };
    case FETCH_USERS_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    case DELETE_USER_REQUEST:
      return { ...state, deleteInProgress: true, deleteError: null };
    case DELETE_USER_SUCCESS:
      return { ...state, deleteInProgress: false };
    case DELETE_USER_ERROR:
      return { ...state, deleteInProgress: false, deleteError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //
const fetchRequest = () => ({ type: FETCH_USERS_REQUEST });
const fetchSuccess = response => ({ type: FETCH_USERS_SUCCESS, payload: response });
const fetchError = e => ({ type: FETCH_USERS_ERROR, error: true, payload: e });
const deleteRequest = () => ({ type: DELETE_USER_REQUEST });
const deleteSuccess = () => ({ type: DELETE_USER_SUCCESS });
const deleteError = e => ({ type: DELETE_USER_ERROR, error: true, payload: e });

// ================ Thunks ================ //
const PAGE_SIZE = 50;

export const loadData = (params, search) => (dispatch, getState, sdk) => {
  dispatch(fetchRequest());

  const { page = 1, q, userType, state: userState } = parse(search) || {};

  return sdk.users
    .query({
      all: true,
      q: q || null,
      userType: userType || null,
      state: userState || null,
      page,
      perPage: PAGE_SIZE,
    })
    .then(response => {
      dispatch(fetchSuccess(response.data));
      return response;
    })
    .catch(e => {
      dispatch(fetchError(storableError(e)));
      throw e;
    });
};

export const deleteUser = id => (dispatch, getState, sdk) => {
  dispatch(deleteRequest());
  return sdk.users
    .adminDelete({ id })
    .then(response => {
      dispatch(deleteSuccess());
      return response;
    })
    .catch(e => {
      dispatch(deleteError(storableError(e)));
      throw e;
    });
};
